interface Props {
  color?: string
  width?: number
  height?: number
}

export const PostIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3842 1.0752C19.2829 0.74988 20.1563 1.54643 19.976 2.4375L19.9252 2.61621L13.9243 19.2061C13.5973 20.1077 12.4229 20.2663 11.8559 19.5537L11.7514 19.3994L8.8764 14.4355L13.3344 9.97949L13.3403 9.97266C13.6381 9.66416 13.803 9.25108 13.7993 8.82227C13.7955 8.39334 13.6231 7.983 13.3198 7.67969C13.0165 7.3765 12.606 7.20392 12.1772 7.2002C11.7485 7.19659 11.3352 7.36141 11.0268 7.65918L11.0209 7.66602L6.56293 12.123L1.60101 9.25C0.715281 8.73687 0.832276 7.42344 1.79437 7.0752L1.7934 7.07422L18.3832 1.0752H18.3842Z"
        stroke={color}
      />
    </svg>
  )
}
